<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-taxwc-tabedit [srv]="srv"></app-taxwc-tabedit> -->
  </mat-tab>

  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-50">[空白]</div>
  </mat-tab>
</mat-tab-group>